module.exports = __webpack_public_path__ + "img/rafael-mota.da4c024d.png";